const findIndexToRemove = (timeBlock, dayOfBlocks) => {
    let indexToRemove;
    let timeToFind = timeBlock[0][0];
    for (let i = 0; i < dayOfBlocks.length; i ++) {
        if (dayOfBlocks[i][0] === timeToFind) {
            indexToRemove = i;
        };
    };
    return indexToRemove;
};

export default findIndexToRemove;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/utils/findIndexToRemove.js